import { render, staticRenderFns } from "./Margin.vue?vue&type=template&id=14a13e1b&"
import script from "./Margin.vue?vue&type=script&lang=ts&"
export * from "./Margin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a13e1b')) {
      api.createRecord('14a13e1b', component.options)
    } else {
      api.reload('14a13e1b', component.options)
    }
    module.hot.accept("./Margin.vue?vue&type=template&id=14a13e1b&", function () {
      api.rerender('14a13e1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/reports/Margin.vue"
export default component.exports